import React, { useEffect, useState } from "react";
import { Modal, Container, Card, Row, Col, Button, Accordion, Table, Badge } from "react-bootstrap";
import { Formik, Field } from "formik";
import { Input, Select } from "../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";

import { CampaignSchema } from './Components';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import * as _products from "../CatalogProducts/operations"
import * as _regions from "../CatalogRegions/operations"
import * as _users from "../CatalogUsers/operations"
import * as _inters from "../CatalogInternalUsers/operations"
import * as _groups from "../CatalogGroups/operations"
import * as _clients from "../CatalogClients/operations"
import * as _tasks from "../CatalogTasks/operations"
import * as _pos from "../CatalogLocations/operations"
import { useHistory } from "react-router-dom";

import * as crud from "./operations"

function Campaign(props) {
    const history = useHistory()

    const [mode, setMode] = useState("default")
    const { user: snap } = useSelector(state => state.auth);
    const user = snap.uid ? snap : snap.payload

    useEffect(loadData, [])
    const document = props.document
    const product_uid = document.products ? Object.keys(document.products) : null
    const [key, setKey] = useState(props.key || "0")
    const [sending, setSending] = useState(false)
    const [clients, setClients] = useState([])
    const [products, setProduct] = useState([])
    const [regions, setRegion] = useState([])
    const [groups, setGroups] = useState([])
    const [tasks, setTasks] = useState([])
    const [users, setUsers] = useState([])
    const [marketing, setMarketing] = useState([])

    const [pos, setPOS] = useState([])


    const [applyAll, setApplyAll] = useState(document.product_task || [])

    const [selected_task, setSelectedTasks] = useState(document.tasks || [])
    const [selected_pos, setSelectedPOS] = useState(document.pos || [])
    const [selected_users, setSelectedUsers] = useState(document.users || [])
    const [selected_products, setSelectedProducts] = useState(product_uid || [])

    const [manageTasks, setManageTasks] = useState(false)
    const [manageProducts, setManageProducts] = useState(false)
    const [managePOS, setManagePOS] = useState(false)
    const [manageUsers, setManageUsers] = useState(false)

    const [currentProducts, setCurrentProducts] = useState([])
    const [currentPOS, setCurrentPOS] = useState([])


    const controllers = {
        regions: regions,
        applyAll: applyAll,
        setApply: setApplyAll,
        groups: groups,

        tasks: tasks,
        manageTasks: manageTasks,
        selectedTasks: selected_task,
        setSelectedTasks: setSelectedTasks,
        toggleManageTasks: () => setManageTasks(!manageTasks),

        products: currentProducts,
        manageProducts: manageProducts,
        selectedProducts: selected_products,
        setSelectedProducts: setSelectedProducts,
        toggleManageProducts: () => setManageProducts(!manageProducts),
        allpos: pos,
        pos: currentPOS,
        managePOS: managePOS,
        setCurrentPOS: setCurrentPOS,
        selectedPOS: selected_pos,
        setSelectedPOS: setSelectedPOS,
        toggleManagePOS: () => setManagePOS(!managePOS),

        marketing: marketing,
        users: [...users, ...marketing],
        manageUsers: manageUsers,
        selectedUsers: selected_users,
        setSelectedUsers: setSelectedUsers,
        toggleManageUsers: () => setManageUsers(!manageUsers)
    }

    function activeKey(_key = "0") {
        return key === _key ? "card-header-title-active" : "card-header-title-no-active"
    }
    function loadData() {
        _clients.getClients(setClients)
        _regions.getClients(setRegion)
        _users.getClients(setUsers)
        _inters.getClients(setMarketing)
        _groups.getClients(setGroups)
        _tasks.getClients(setTasks)
        _pos.getClients((args) => {
            setPOS(args)
            setCurrentPOS(args)
        })
        _products.getClients((args) => {
            setProduct(args)
            setCurrentProducts(args)
        })
    }
    const toInputUppercase = e => {
        e.target.value = ("" + e.target.value).toUpperCase();
    };
    return (
        <>
            <Formik
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={document}
                validationSchema={CampaignSchema}
                onSubmit={(values) => {
                    const products = controllers.products
                        .filter(p => selected_products.includes(p.uid))
                        .reduce((pre, cur) => ({
                            ...pre, [cur.uid]: {
                                units: cur.units || 1,
                                price: cur.price
                            }
                        }), {})

                    if (!values.end_date) {
                        values.end_date = values.start_date
                    }
                    if (!values.type) {
                        values.type = "event"
                    }
                    if (!values.salary) {
                        values.salary = 0
                    }
                    const doc = { ...values, products, users: selected_users, product_task: applyAll, tasks: selected_task, pos: selected_pos, mode, author: user.uid }
                    crud.updateClient(doc).then((args) => {
                        console.log(args)
                        setSending(false)
                        history.push({
                            pathname: "/campaign"
                        })
                    }).catch(() => {
                        setSending(false)

                    })
                }}
            >
                {(props) => (
                    <>
                        <ManageTasks {...controllers} formik={props} />
                        <ManageProducts {...controllers} formik={props} />
                        <ManagePOS {...controllers} formik={props} />
                        <ManageUsers {...controllers} formik={props} />
                        <Container>
                            <Accordion activeKey={key} >
                                <Card className="card card-custom gutter-b">
                                    <Card.Title className="pt-7 pl-7 pr-7">
                                        <h2>
                                            {document.uid ? "Edit Campaign" : "New Campaign"}{" "}
                                            {props.values.name && <span className="h1"><b>"{props.values.name}"</b></span>}
                                        </h2>
                                    </Card.Title>
                                    <Card.Body>
                                        <div
                                            onSubmit={props.handleSubmit}
                                            className="form form-label-right"
                                        >
                                            <hr />
                                            <Accordion.Toggle as={Card.Body} eventKey="0" className="card-header-title">
                                                <h2>
                                                    <span className={`card-header-title ${activeKey("0")} cursor-pointer`} onClick={() => setKey("0")}>About Campaign</span>
                                                    <span className="svg-icon cursor-pointer" onClick={() => setKey("0")} title="jump">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
                                                    </span>
                                                </h2>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="0" className="mb-5">
                                                <Container>
                                                    <Row className="every-child-margin">
                                                        <Col lg={6} xs={12}>
                                                            <Field
                                                                onInput={toInputUppercase}
                                                                name="name"
                                                                component={Input}
                                                                placeholder="Name"
                                                                label="Name"
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={props.values.name}

                                                            />
                                                        </Col>
                                                        <Col lg={6} xs={12}>
                                                            <Field
                                                                onInput={toInputUppercase}
                                                                name="description"
                                                                component={Input}
                                                                placeholder="Description"
                                                                label="Description"
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={props.values.description}

                                                            />
                                                        </Col>
                                                        <Col lg={6} xs={12}>
                                                            <Field
                                                                onInput={toInputUppercase}
                                                                name="cost"
                                                                type="number"
                                                                component={Input}
                                                                placeholder="Insert Cost"
                                                                label="Cost"
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={props.values.cost}

                                                            />
                                                        </Col>
                                                        <Col lg={6} xs={12}>
                                                        </Col>

                                                        <Col lg={6} xs={12}>
                                                            <Select

                                                                name="client"
                                                                label="Customer"
                                                                onChange={(event) => {
                                                                    const _products = [...products].filter(p => p.client === event.target.value)
                                                                    setCurrentProducts(_products)
                                                                    setSelectedProducts([])
                                                                    setSelectedPOS([])
                                                                    setSelectedUsers([])
                                                                    props.handleChange(event)
                                                                }}
                                                                value={props.values.client}
                                                            >
                                                                <option key="0" value="--null--">
                                                                    --null--
                                                                </option>
                                                                {clients.map((client) => (
                                                                    <option
                                                                        key={client.uid}
                                                                        value={client.uid}
                                                                    >
                                                                        {client.name}
                                                                    </option>
                                                                ))}


                                                            </Select>

                                                        </Col>
                                                        <Col lg={6} xs={12}>
                                                            <Select

                                                                name="type"
                                                                label="type"
                                                                onChange={(event) => {
                                                                    setSelectedUsers([])
                                                                    props.handleChange(event)
                                                                }}
                                                                value={props.values.type}

                                                            >
                                                                {["event", "service"]
                                                                    .map((type, key) => (
                                                                        <option
                                                                            key={key}
                                                                            value={type}
                                                                        >
                                                                            {type}
                                                                        </option>
                                                                    ))}

                                                            </Select>
                                                        </Col>
                                                        <Col lg={6} xs={12}>
                                                            <Select

                                                                name="state"
                                                                label="State"

                                                                onChange={(event) => {
                                                                    const _pos = [...pos].filter(p => p.state === event.target.value)
                                                                    console.log(_pos)
                                                                    setCurrentPOS(_pos)
                                                                    setSelectedPOS([])
                                                                    props.handleChange(event)
                                                                }}
                                                                value={props.values.state}
                                                            >
                                                                <option key="0" value="--null--">
                                                                    --null--
                                                                </option>
                                                                {([...clients]
                                                                    .filter(client => client.uid === props.values.client)
                                                                    .pop()?.states || [])
                                                                    .map((state, key) => (
                                                                        <option
                                                                            key={key}
                                                                            value={state}
                                                                        >
                                                                            {state}
                                                                        </option>
                                                                    ))}

                                                            </Select>
                                                        </Col>
                                                        {/* <Col lg={6} xs={12}>
                                                            <Select
                                                                
                                                                name="region"
                                                                label="Region"
                                                                onChange={(event) => {
                                                                    const _pos = [...pos].filter(p => p.region === event.target.value)
                                                                    setCurrentPOS(_pos)
                                                                    setSelectedPOS([])
                                                                    props.handleChange(event)
                                                                }}
                                                                value={props.values.region}
                                                                
                                                            >
                                                                <option key="0" value="--null--">
                                                                    --null--
                                                                </option>
                                                                {[...regions]
                                                                    .filter(region => region.state === props.values.state)
                                                                    .map(region => (
                                                                        <option
                                                                            key={region.uid}
                                                                            value={region.uid}
                                                                        >
                                                                            {region.name}
                                                                        </option>
                                                                    ))}
                                                            </Select>
                                                        </Col> */}

                                                        <Col lg={12} xs={12} className="mt-5">
                                                            <Button onClick={() => setKey("1")}>
                                                                Continue
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Collapse>
                                            <hr />
                                            <Accordion.Toggle as={Card.Body} eventKey="1" className="card-header-title">
                                                <h2>
                                                    <span className={`card-header-title ${activeKey("1")} cursor-pointer`} onClick={() => setKey("1")}>Work Description</span>
                                                    <span className="svg-icon cursor-pointer" onClick={() => setKey("1")} title="jump">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
                                                    </span>
                                                </h2>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="1">
                                                <Container>
                                                    <Row className="every-child-margin">
                                                        <Col xs={12} lg={6}>
                                                            <Field

                                                                type="date"
                                                                name="start_date"
                                                                component={Input}
                                                                label={props.values.type === "service" ? "Start Date" : "Date"}


                                                            />
                                                        </Col>

                                                        <Col xs={12} lg={6}>
                                                            {(props.values.type === "service" && <Field
                                                                type="date"
                                                                name="end_date"
                                                                component={Input}
                                                                label="End Date"


                                                            />)}
                                                        </Col>

                                                        <Col xs={12} lg={6}>
                                                            <Field
                                                                type="time"
                                                                name="start_time"
                                                                component={Input}
                                                                label="Start at"


                                                            />
                                                        </Col>
                                                        <Col xs={12} lg={6}>
                                                            <Field
                                                                type="time"
                                                                name="end_time"
                                                                component={Input}
                                                                label="End at"


                                                            />
                                                        </Col>
                                                        <Col xs={12} lg={12}>
                                                            <Field
                                                                onInput={toInputUppercase}
                                                                type="text"
                                                                name="materials"
                                                                component={Input}
                                                                placeholder="List all materials"
                                                                label="Materials"


                                                            />
                                                        </Col>
                                                        <Col lg={6} xs={12} className="mt-5">
                                                            <Button variant="secondary" onClick={() => setKey("0")}>
                                                                Return
                                                            </Button>
                                                            <Button onClick={() => setKey("2")} className="mx-1">
                                                                Continue
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Collapse>
                                            <hr />
                                            <Accordion.Toggle as={Card.Body} eventKey="2" className="card-header-title">
                                                <h2>
                                                    <span className={`card-header-title ${activeKey("2")} cursor-pointer`} onClick={() => setKey("2")}>POS</span>
                                                    <span className="svg-icon cursor-pointer" onClick={() => setKey("2")} title="jump">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
                                                    </span>
                                                </h2>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="2">
                                                <Container>
                                                    <Row className="every-child-margin">

                                                        <Col lg={12} xs={12} className="mt-5">
                                                            <Button variant="success" onClick={controllers.toggleManagePOS} disabled={!props.values.state}>
                                                                Add POS
                                                                </Button>
                                                            {(selected_pos.length ?
                                                                <Button variant="danger" className="mx-1" onClick={() => controllers.setSelectedProducts([])}>
                                                                    Delete POS
                                                                </Button> : null)
                                                            }
                                                        </Col>
                                                        <Col xs={12} className="mt-5">

                                                            {selected_pos.length ?
                                                                <div className="mt-5" style={{ overflowY: "scroll", height: "100%", maxHeight: "35vh" }}>
                                                                    <Table hover size="md">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Name</th>
                                                                                <th>Description</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {pos
                                                                                .filter(pos => selected_pos.includes(pos.uid))
                                                                                .sort((a, b) => {
                                                                                    if (a.name < b.name) { return -1; }
                                                                                    if (a.name > b.name) { return 1; }
                                                                                    return 0;
                                                                                })
                                                                                .map(pos => (
                                                                                    <tr key={pos.uid}>
                                                                                        <td>{pos.name}</td>
                                                                                        <td>{pos.description}</td>
                                                                                        <td>
                                                                                            <div
                                                                                                onClick={() => {
                                                                                                    const newSelected = selected_pos.filter(e => e !== pos.uid)
                                                                                                    setSelectedPOS(newSelected)
                                                                                                }}
                                                                                                title="Delete"
                                                                                                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                                                                            >
                                                                                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                                                    <SVG
                                                                                                        src={toAbsoluteUrl(
                                                                                                            "/media/svg/icons/General/Trash.svg"
                                                                                                        )}
                                                                                                    />
                                                                                                </span>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </div> :
                                                                <div className="row" >
                                                                    <div className="col-md-8">
                                                                        <span className="svg-icon svg-icon-full">
                                                                            <img
                                                                                alt="no-region"
                                                                                width="40%"
                                                                                className="rotate-45 mb-3 mr-5F"
                                                                                src="https://pbs.twimg.com/media/Dpr4ojcXcAAZOS9.png" />
                                                                            <label>
                                                                                <b>Don't</b> have any <b>region</b> assigned
                                                                    </label>
                                                                        </span>
                                                                    </div>
                                                                </div>}
                                                        </Col>

                                                        <Col lg={6} xs={12} className="mt-5">
                                                            <Button variant="secondary" onClick={() => setKey("1")}>
                                                                Return
                                                            </Button>
                                                            <Button onClick={() => setKey("3")} className="mx-1">
                                                                Continue
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Collapse>
                                            <hr />
                                            <Accordion.Toggle as={Card.Body} eventKey="3" className="card-header-title">
                                                <h2>
                                                    <span className={`card-header-title ${activeKey("3")} cursor-pointer`} onClick={() => setKey("3")}>Products</span>
                                                    <span className="svg-icon cursor-pointer" onClick={() => setKey("3")} title="jump">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
                                                    </span>
                                                </h2>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="3">
                                                <Container>
                                                    <Row className="every-child-margin">
                                                        <Col lg={12} xs={12} className="mt-5">
                                                            <Button variant="success" onClick={controllers.toggleManageProducts} disabled={!props.values.client}>
                                                                Add Products
                                                            </Button>
                                                            {(selected_products.length ?
                                                                <Button variant="danger" className="mx-1" onClick={() => controllers.setSelectedProducts([])}>
                                                                    Delete Products
                                                                </Button> : null)
                                                            }
                                                        </Col>
                                                        {!props.values.client && (<small className="text-muted"><b>Dont</b>have any client selected</small>)}
                                                        <Col xs={12} className="mt-5">
                                                            {selected_products.length ?
                                                                <>
                                                                    <div className="mt-5" style={{ overflowY: "scroll", height: "100%", maxHeight: "35vh" }}>
                                                                        <Table hover size="md">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Name</th>
                                                                                    <th>Desciption</th>
                                                                                    <th>Units</th>
                                                                                    <th>Price ($)</th>
                                                                                    <th></th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {controllers.products
                                                                                    .filter(product => selected_products.includes(product.uid))
                                                                                    .sort((a, b) => {
                                                                                        if (a.name < b.name) { return -1; }
                                                                                        if (a.name > b.name) { return 1; }
                                                                                        return 0;
                                                                                    })
                                                                                    .map(product => (
                                                                                        <tr key={product.uid}>
                                                                                            <td>{product.name}</td>
                                                                                            <td>{product.description}</td>
                                                                                            <td>
                                                                                                <Field
                                                                                                    type="number"
                                                                                                    name={`products.${product.uid}.units`}
                                                                                                    defaultValue={product.units || 1}
                                                                                                    onChange={({ target }) => {
                                                                                                        console.log({ product })
                                                                                                        const [_product] = [...controllers.products].filter(p => p.uid === product.uid)
                                                                                                        if (!_product) {
                                                                                                            return;
                                                                                                        }
                                                                                                        const newProducts = [...controllers.products].filter(p => p.uid !== product.uid)
                                                                                                        const { value } = target
                                                                                                        _product.units = Number(value)
                                                                                                        setCurrentProducts([...newProducts, _product])
                                                                                                    }}
                                                                                                    component={Input}

                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <Field
                                                                                                    type="number"
                                                                                                    name={`products.${product.uid}.price`}
                                                                                                    defaultValue={product.price}
                                                                                                    onChange={({ target }) => {
                                                                                                        console.log({ product })
                                                                                                        const [_product] = [...controllers.products].filter(p => p.uid === product.uid)
                                                                                                        if (!_product) {
                                                                                                            return;
                                                                                                        }
                                                                                                        const newProducts = [...controllers.products].filter(p => p.uid !== product.uid)
                                                                                                        const { value } = target
                                                                                                        _product.price = Number(value)
                                                                                                        setCurrentProducts([...newProducts, _product])
                                                                                                    }}
                                                                                                    component={Input}

                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <div
                                                                                                    onClick={() => {
                                                                                                        const newSelected = selected_products.filter(e => e !== product.uid)
                                                                                                        setSelectedProducts(newSelected)
                                                                                                    }}
                                                                                                    title="Delete"
                                                                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                                                                                >
                                                                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                                                        <SVG
                                                                                                            src={toAbsoluteUrl(
                                                                                                                "/media/svg/icons/General/Trash.svg"
                                                                                                            )}
                                                                                                        />
                                                                                                    </span>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </div>
                                                                    <hr />
                                                                    <div className="d-flex justify-content-end">
                                                                        <h4>Total: ${controllers.products
                                                                            .filter(product => selected_products.includes(product.uid))
                                                                            .reduce((pre, cur) => pre + ((cur.units || 1) * cur.price), 0)
                                                                            .toFixed(2)}
                                                                        </h4>
                                                                    </div>
                                                                </> :
                                                                <div className="row" >
                                                                    <div className="col-md-8">
                                                                        <span className="svg-icon svg-icon-full">
                                                                            <img
                                                                                alt="no-products"
                                                                                width="40%"
                                                                                className="rotate mb-3 mr-5"
                                                                                src={toAbsoluteUrl("/media/misc/no-products.png")}
                                                                            />
                                                                            <label>
                                                                                <b>Don't</b> have any <b>products</b> assigned
                                                                            </label>
                                                                        </span>
                                                                    </div>
                                                                </div>}
                                                        </Col>
                                                        <Col lg={6} xs={12} className="mt-5">
                                                            <Button variant="secondary" onClick={() => setKey("2")}>
                                                                Return
                                                            </Button>
                                                            <Button onClick={() => setKey("4")} className="mx-1">
                                                                Continue
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Collapse>
                                            <hr />
                                            <Accordion.Toggle as={Card.Body} eventKey="4" className="card-header-title">
                                                <h2>
                                                    <span className={`card-header-title ${activeKey("4")} cursor-pointer`} onClick={() => setKey("4")}>Tasks</span>
                                                    <span className="svg-icon cursor-pointer" onClick={() => setKey("4")} title="jump">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
                                                    </span>
                                                </h2>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="4">
                                                <Container>
                                                    <Row className="every-child-margin">
                                                        <Col lg={6} xs={12} className="mt-5">
                                                            <Button variant="success" onClick={controllers.toggleManageTasks}>
                                                                Add Tasks
                                                            </Button>
                                                            {(selected_task.length ?
                                                                <Button variant="danger" className="mx-1" onClick={() => controllers.setSelectedTasks([])}>
                                                                    Delete Tasks
                                                                </Button> : null)
                                                            }
                                                        </Col>
                                                        <Col xs={12} className="mt-5">
                                                            {selected_task.length ?
                                                                <div className="mt-5" style={{ overflowY: "scroll", height: "100%", maxHeight: "35vh" }}>

                                                                    <Table hover size="md">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Apply to all Products</th>
                                                                                <th>Name</th>
                                                                                <th>Type(s)</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {tasks
                                                                                .filter(task => selected_task.includes(task.uid))
                                                                                .sort((a, b) => {
                                                                                    if (a.name < b.name) { return -1; }
                                                                                    if (a.name > b.name) { return 1; }
                                                                                    return 0;
                                                                                })
                                                                                .map(task => (
                                                                                    <tr key={task.uid}>
                                                                                        <td>
                                                                                            <input type="checkbox" className="checkbox-table"
                                                                                                defaultChecked={applyAll[task.uid]}
                                                                                                onClick={() => {
                                                                                                    applyAll[task.uid] = !applyAll[task.uid]
                                                                                                    console.log(applyAll)

                                                                                                    setApplyAll(applyAll)
                                                                                                }}
                                                                                            />
                                                                                        </td>
                                                                                        <td>{task.name}</td>
                                                                                        <td><TasksTypeColumnFormatter row={task} /></td>
                                                                                        <td>
                                                                                            <div
                                                                                                onClick={() => {
                                                                                                    const newSelected = selected_task.filter(e => e !== task.uid)
                                                                                                    setSelectedTasks(newSelected)
                                                                                                }}
                                                                                                title="Delete"
                                                                                                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                                                                            >
                                                                                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                                                    <SVG
                                                                                                        src={toAbsoluteUrl(
                                                                                                            "/media/svg/icons/General/Trash.svg"
                                                                                                        )}
                                                                                                    />
                                                                                                </span>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                        </tbody>
                                                                    </Table> </div> :
                                                                <div className="row" >
                                                                    <div className="col-md-8">
                                                                        <span className="svg-icon svg-icon-full">
                                                                            <img
                                                                                alt="no-taskss"
                                                                                width="40%"
                                                                                src="https://pbs.twimg.com/media/Dpr4ojcXcAAZOS9.png"
                                                                            />
                                                                            <label>
                                                                                <b>Don't</b> have any <b>tasks</b> assigned
                                                                            </label>
                                                                        </span>
                                                                    </div>
                                                                </div>}
                                                        </Col>
                                                        <Col lg={6} xs={12} className="mt-5">
                                                            <Button variant="secondary" onClick={() => setKey("3")}>
                                                                Return
                                                            </Button>
                                                            <Button onClick={() => setKey("5")} className="mx-1">
                                                                Continue
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Collapse>
                                            <hr />
                                            <Accordion.Toggle as={Card.Body} eventKey="5" className="card-header-title">
                                                <h2>
                                                    <span className={`card-header-title ${activeKey("5")} cursor-pointer`} onClick={() => setKey("5")}>Users</span>
                                                    <span className="svg-icon cursor-pointer" onClick={() => setKey("5")} title="jump">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
                                                    </span>
                                                </h2>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="5">
                                                <Container>
                                                    <Row className="every-child-margin">
                                                        <Col lg={12} xs={12} className="mt-5">
                                                            <Button variant="success" onClick={controllers.toggleManageUsers}>
                                                                Add Users
                                                            </Button>
                                                            {(selected_users.length ?
                                                                <Button variant="danger" className="mx-1" onClick={() => controllers.setSelectedTasks([])}>
                                                                    Delete Users
                                                                </Button> : null)
                                                            }
                                                        </Col>
                                                        <Col xs={12} className="mt-5">
                                                            {selected_users.length ?
                                                                <div className="mt-5" style={{ overflowY: "scroll", height: "100%", maxHeight: "35vh" }}>

                                                                    <Table hover size="md">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Photo</th>
                                                                                <th>Name</th>
                                                                                <th>Type</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {(props.values.type === "service" ?
                                                                                controllers.marketing :
                                                                                controllers.users)
                                                                                .filter(user => selected_users.includes(user.uid))
                                                                                .sort((a, b) => {
                                                                                    if (a.name < b.name) { return -1; }
                                                                                    if (a.name > b.name) { return 1; }
                                                                                    return 0;
                                                                                })
                                                                                .sort((a, b) => {
                                                                                    if (a.type < b.type) { return -1; }
                                                                                    if (a.type > b.type) { return 1; }
                                                                                    return 0;
                                                                                })
                                                                                .map(user => (
                                                                                    <tr key={user.uid}>
                                                                                        <td>
                                                                                            <div className="symbol symbol-50 symbol-light">
                                                                                                <span className="symbol-label">
                                                                                                    <img
                                                                                                        alt="no-user"
                                                                                                        className="image-fluid rounded"
                                                                                                        width="100%"
                                                                                                        height="100%"
                                                                                                        src={user.image || user.photoURL || "https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/crash_test_dummy.png"}
                                                                                                    />
                                                                                                </span>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>{user.name} <small>({user.email})</small></td>
                                                                                        <td>{user.type}</td>

                                                                                        <td>
                                                                                            <div
                                                                                                onClick={() => {
                                                                                                    const newSelected = selected_users.filter(e => e !== user.uid)
                                                                                                    setSelectedUsers(newSelected)
                                                                                                }}
                                                                                                title="Delete"
                                                                                                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                                                                            >
                                                                                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                                                    <SVG
                                                                                                        src={toAbsoluteUrl(
                                                                                                            "/media/svg/icons/General/Trash.svg"
                                                                                                        )}
                                                                                                    />
                                                                                                </span>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                        </tbody>
                                                                    </Table> </div> :
                                                                <div className="row" >
                                                                    <div className="col-md-8">
                                                                        <span className="svg-icon svg-icon-full">
                                                                            <img
                                                                                alt="no-users"
                                                                                width="40%"
                                                                                src="https://pbs.twimg.com/media/Dpr4ojcXcAAZOS9.png"
                                                                            />
                                                                            <label>
                                                                                <b>Don't</b> have any <b>users</b> assigned
                                                                            </label>
                                                                        </span>
                                                                    </div>
                                                                </div>}
                                                        </Col>
                                                        <Col lg={12} xs={12} className="mt-5">
                                                            <Button variant="secondary" onClick={() => setKey("4")}>
                                                                Return
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Collapse>
                                            <Row className="d-flex justify-content-end container p-2 mt-5">
                                                <Button
                                                    disabled={sending}
                                                    variant="outline-danger"
                                                    onClick={() => {
                                                        history.push({
                                                            pathname: "/campaign"
                                                        })
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    variant="warning"
                                                    disabled={sending}

                                                    onClick={() => {
                                                        setMode("draft")
                                                        setSending(true)
                                                        props.handleSubmit()
                                                    }}
                                                    className="mx-2">
                                                    {(sending && mode === "draft") ?
                                                        <div className="d-flex align-items-center">
                                                            <div className="mr-2">Loading...</div>
                                                            <div className="spinner spinner-white mr-10"></div>
                                                        </div> :
                                                        "Save Draft"}

                                                </Button>
                                                <Button
                                                    variant="success"
                                                    disabled={sending}
                                                    onClick={() => {
                                                        setMode("default")
                                                        setSending(true)
                                                        props.handleSubmit()
                                                    }}
                                                >
                                                    {
                                                        (sending && mode === "default") ?
                                                            <div className="d-flex align-items-center">
                                                                <div className="mr-2">Loading...</div>
                                                                <div className="spinner spinner-white mr-10"></div>
                                                            </div> :
                                                            document.uid ? "Update Campaign" : "Create Campaign"}
                                                </Button>
                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Accordion>
                        </Container>
                    </>
                )}
            </Formik>


        </>
    )
}
function ManageUsers(props) {
    const [selected, setSelected] = useState(props.selectedUsers || [])
    const [userGroups, setUserGroups] = useState([])
    useEffect(() => {
        if (props.formik.values.type === "service") {
            setUserGroups(props.marketing)
        } else {
            setUserGroups([...props.users].filter(t => t.work_type === "event"))

        }
        setSelected(props.selectedUsers)

    }, [props.selectedUsers, props.formik.values.group, props.formik.values.type, props.marketing, props.users])
    const [filter, setFilter] = useState("")
    const fields = ["name"]

    function handleSelect(uid) {
        if (selected.includes(uid)) {
            const newSelected = selected.filter(e => e !== uid)
            setSelected(newSelected)
        } else {
            setSelected([...selected, uid])
        }
    }
    function selectAll(rows) {
        setSelected(rows)
    }
    console.log(userGroups)
    const _userGroups = userGroups
        .filter((row) => {
            if ((props.formik.values.type || "event") === "event") {
                return true
            }
            console.log(row.state)
            return row.work_state === props.formik.values.state
        })

        .filter((data) => {
            for (const field of fields) {
                const value = data[field].toUpperCase();
                if (value.indexOf(filter.toUpperCase()) >= 0) {
                    return true;
                }
            }
            return false;
        })
    console.log(_userGroups, props.formik.values.state, props.formik.values.type)
    return (
        <Modal show={props.manageUsers} onHide={props.toggleManageUsers} size="lg">
            <Modal.Header>
                <h2>Manage Users</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-4">
                        {(props.formik.values.type || "event") === "event" && <Select
                            name="group"
                            label="group"
                            onChange={(event) => {
                                setSelected([])
                                if (event.target.value === "-null-") {
                                    if (props.formik.values.type === "service") {
                                        setUserGroups(props.maketing)
                                    } else {
                                        setUserGroups([...props.users].filter(t => t.work_type === "event"))

                                    }
                                    return;
                                }
                                _groups
                                    .getUsersByGroup(event.target.value)
                                    .then(({ data }) => {
                                        const list = data.payload
                                        const uids = [...list].map(r => r.uid)
                                        const removed = list.filter((r, i) => i === uids.indexOf(r.uid)).filter(e => e.work_type === "event" || !e.work_type)
                                        setUserGroups(removed)
                                    })
                                props.formik.handleChange(event)
                            }}
                            value={props.formik.values.group ?? "-all-"}

                        >
                            <option
                                value="-null-"
                            >
                                -all-
                                </option>
                            {props.groups.map(group => (
                                <option
                                    key={group.uid}
                                    value={group.uid}
                                >
                                    {group.name}
                                </option>
                            ))}

                        </Select>}
                    </div>
                    <div className="col-lg-4 col-xs-12">
                        {(props.formik.values.type || "event") === "event" && <Field
                            name="salary"
                            component={Input}
                            placeholder="0"
                            label="Salary"
                            type="number"
                            onChange={props.formik.handleChange}
                            onBlur={props.formik.handleBlur}
                            value={props.formik.values.salary}

                        />}
                    </div>
                    <div className="col-lg-4 col-xs-12">
                        {/* <br />
                        {(props.formik.values.type || "event") === "event" &&
                            (<Button variant="info" className="mt-2">
                                Add User Manually
                            </Button>)
                        } */}
                    </div>
                    <div className="col-lg-12">
                        <hr style={{ borderColor: "white" }} />
                    </div>
                    <div className="col-lg-4 ">
                        <input
                            type="text"
                            className="form-control"
                            name="searchText"
                            placeholder="Search"
                            onChange={({ target }) => setFilter(target.value)}
                        />
                        <small className="form-text text-muted"><b>Search</b> in all fields</small>
                    </div>

                </div>
                <Col
                    xs={12}
                    style={{ overflowY: "scroll", height: "100%", maxHeight: "40vh" }}
                >
                    <Table hover size="md">
                        <thead>
                            <tr>
                                <th>
                                    <input type="checkbox" className="checkbox-table"
                                        checked={_userGroups.length === selected.length}
                                        onChange={() => { }}
                                        onClick={() => _userGroups.length === selected.length ? selectAll([]) : selectAll(_userGroups.map(t => t.uid))}
                                    />
                                </th>
                                <th>Photo</th>
                                <th>Name</th>
                                <th>Type</th>

                                {/* <th>Type(s)</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {_userGroups.sort((a, b) => {
                                if (a.name < b.name) { return -1; }
                                if (a.name > b.name) { return 1; }
                                return 0;
                            })
                                .sort((a, b) => {
                                    if (a.type < b.type) { return -1; }
                                    if (a.type > b.type) { return 1; }
                                    return 0;
                                })
                                .map(user => (
                                    <tr key={user.uid} onClick={() => handleSelect(user.uid)}>
                                        <td>
                                            <input type="checkbox" className="checkbox-table"
                                                checked={selected.includes(user.uid)}
                                                onChange={() => { }}
                                                onClick={() => handleSelect(user.uid)}
                                            />
                                        </td>
                                        <td>
                                            <div className="symbol symbol-50 symbol-light">
                                                <span className="symbol-label">
                                                    <img
                                                        alt="no-user"
                                                        className="image-fluid rounded"
                                                        width="100%"
                                                        height="100%"
                                                        src={user.image || user.photoURL || "https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/crash_test_dummy.png"}
                                                    />
                                                </span>
                                            </div>
                                        </td>

                                        <td>{user.name} <small>({user.email})</small></td>
                                        <td>{user.type}</td>

                                    </tr>
                                ))}

                        </tbody>
                    </Table>
                </ Col>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.toggleManageUsers}>
                    Cancel
               </Button>
                <Button variant="success" onClick={() => {
                    props.setSelectedUsers(selected)
                    props.toggleManageUsers()
                }}>
                    Save
               </Button>
            </Modal.Footer>
        </Modal>
    )
}
function ManageTasks(props) {
    const [selected, setSelected] = useState(props.selectedTasks || [])
    useEffect(() => {
        setSelected(props.selectedTasks)
    }, [props.selectedTasks])
    const [filter, setFilter] = useState("")
    const fields = ["name", "description"]
    const _tasks = props.tasks.filter((data) => {
        for (const field of fields) {
            const string = String(data[field] ?? "")
            const value = string.toUpperCase();
            if (value.indexOf(filter.toUpperCase()) >= 0) {
                return true;
            }
        }
        return false;
    })

    function handleSelect(uid) {
        if (selected.includes(uid)) {
            const newSelected = selected.filter(e => e !== uid)
            setSelected(newSelected)
        } else {
            setSelected([...selected, uid])
        }
    }
    function selectAll(rows) {
        setSelected(rows)
    }
    return (
        <Modal show={props.manageTasks} onHide={props.toggleManageTasks} size="lg">
            <Modal.Header>
                <h2>Manage Tasks</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-lg-4 ">
                        <input
                            type="text"
                            className="form-control"
                            name="searchText"
                            placeholder="Search"
                            onChange={({ target }) => setFilter(target.value)}
                        />
                        <small className="form-text text-muted"><b>Search</b> in all fields</small>
                    </div>
                    <div className="col-lg-4 ">
                        {/* <Button >
                            Create Task
                        </Button> */}
                    </div>
                </div>
                <Col
                    xs={12}
                    style={{ overflowY: "scroll", height: "100%", maxHeight: "40vh" }}
                >
                    <Table hover size="md">
                        <thead>
                            <tr>
                                <th>
                                    <input type="checkbox" className="checkbox-table"
                                        checked={_tasks.length === selected.length}
                                        onChange={() => { }}
                                        onClick={() => _tasks.length === selected.length ? selectAll([]) : selectAll(_tasks.map(t => t.uid))}
                                    />
                                </th>
                                <th>Name</th>
                                <th>Type(s)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {_tasks
                                .sort((a, b) => {
                                    if (a.name < b.name) { return -1; }
                                    if (a.name > b.name) { return 1; }
                                    return 0;
                                })
                                .map(task => (
                                    <tr key={task.uid} onClick={() => handleSelect(task.uid)}>
                                        <td>
                                            <input type="checkbox" className="checkbox-table"
                                                checked={selected.includes(task.uid)}
                                                onChange={() => { }}
                                                onClick={() => handleSelect(task.uid)}
                                            />
                                        </td>
                                        <td>{task.name}</td>
                                        <td><TasksTypeColumnFormatter row={task} /></td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.toggleManageTasks}>
                    Cancel
               </Button>
                <Button variant="success" onClick={() => {
                    props.setSelectedTasks(selected)
                    const apply = [...selected].reduce((pre, cur) => ({
                        ...pre, [cur]: true
                    }), {})
                    props.setApply(apply)
                    props.toggleManageTasks()
                }}>
                    Save
               </Button>
            </Modal.Footer>
        </Modal>
    )
}
function ManageProducts(props) {
    const [selected, setSelected] = useState(props.selectedProducts || [])
    useEffect(() => {
        setSelected(props.selectedProducts)
    }, [props.selectedProducts])
    const [filter, setFilter] = useState("")
    const fields = ["name", "description", "category"]
    const _products = props.products.filter((data) => {
        for (const field of fields) {
            const _value = data[field] || ""
            const value = _value.toUpperCase();
            if (value.indexOf(filter.toUpperCase()) >= 0) {
                return true;
            }
        }
        return false;
    })

    function handleSelect(uid) {
        if (selected.includes(uid)) {
            const newSelected = selected.filter(e => e !== uid)
            setSelected(newSelected)
        } else {
            setSelected([...selected, uid])
        }
    }
    function selectAll(rows) {
        setSelected(rows)
    }
    return (
        <Modal show={props.manageProducts} onHide={props.toggleManageProducts} size="lg" >
            <Modal.Header>
                <h2>Manage Products</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-lg-4 ">
                        <input
                            type="text"
                            className="form-control"
                            name="searchText"
                            placeholder="Search"
                            onChange={({ target }) => setFilter(target.value)}
                        />
                        <small className="form-text text-muted"><b>Search</b> in all fields</small>
                    </div>
                    <div className="col-lg-4 ">
                        {/* <Button >
                            Create Product
                        </Button> */}
                    </div>
                </div>
                <Col
                    xs={12}
                    style={{ overflowY: "scroll", height: "100%", maxHeight: "40vh" }}
                >
                    <Table hover size="md">
                        <thead>
                            <tr>
                                <th>
                                    <input type="checkbox" className="checkbox-table"
                                        checked={_products.length === selected.length}
                                        onChange={() => { }}
                                        onClick={() => _products.length === selected.length ? selectAll([]) : selectAll(_products.map(p => p.uid))}
                                    />
                                </th>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Category</th>
                            </tr>
                        </thead>
                        <tbody>
                            {_products
                                .sort((a, b) => {
                                    if (a.name < b.name) { return -1; }
                                    if (a.name > b.name) { return 1; }
                                    return 0;
                                })
                                .map(product => (
                                    <tr key={product.uid} onClick={() => handleSelect(product.uid)}>
                                        <td>
                                            <input type="checkbox" className="checkbox-table"
                                                checked={selected.includes(product.uid)}
                                                onChange={() => { }}
                                                onClick={() => handleSelect(product.uid)}
                                            />
                                        </td>
                                        <td>{product.name}</td>
                                        <td>{product.description}</td>
                                        <td>{product.category}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.toggleManageProducts}>
                    Cancel
               </Button>
                <Button variant="success" onClick={() => {
                    props.setSelectedProducts(selected)
                    props.toggleManageProducts()
                }}>
                    Save
               </Button>
            </Modal.Footer>
        </Modal>
    )
}
function ManagePOS(props) {
    const [selected, setSelected] = useState(props.selectedPOS || [])
    useEffect(() => {
        setSelected(props.selectedPOS)
    }, [props.selectedPOS])
    const [filter, setFilter] = useState("")
    const fields = ["name", "description"]
    const _pos = props.pos.filter((data) => {
        for (const field of fields) {
            const string = String(data[field] ?? "")
            const value = string.toUpperCase();
            if (value.indexOf(filter.toUpperCase()) >= 0) {
                return true;
            }
        }
        return false;
    })

    function handleSelect(uid) {
        if (selected.includes(uid)) {
            const newSelected = selected.filter(e => e !== uid)
            setSelected(newSelected)

        } else {
            if (props.formik.values.type !== "service") {
                setSelected([uid])
            } else {
                setSelected([...selected, uid])
            }
        }
    }
    function selectAll(rows) {
        setSelected(rows)
    }
    return (
        <Modal show={props.managePOS} onHide={props.toggleManagePOS} size="lg" >
            <Modal.Header>
                <h2>Manage POS</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-lg-4 ">
                        <label>Search</label>
                        <input
                            type="text"
                            className="form-control"
                            name="searchText"
                            placeholder="Search"
                            onChange={({ target }) => setFilter(target.value)}
                        />
                        <small className="form-text text-muted"><b>Search</b> in all fields</small>
                    </div>
                    <div className="col-lg-4">
                        <Select

                            name="region"
                            label="Region"
                            onChange={(event) => {
                                if (event.target.value === "-all-") {
                                    props.setCurrentPOS(props.allpos)
                                } else {
                                    const _pos = [...props.allpos].filter(p => p.region === event.target.value)
                                    props.setCurrentPOS(_pos)
                                }
                                props.setSelectedPOS([])
                                props.formik.handleChange(event)
                            }}
                            value={props.formik.values.region}

                        >
                            <option key="0" value="-all-" >
                                -all-
                            </option>
                            {[...props.regions]
                                .filter(region => region.state === props.formik.values.state)
                                .map(region => (
                                    <option
                                        key={region.uid}
                                        value={region.uid}
                                    >
                                        {region.name}
                                    </option>
                                ))}
                        </Select>
                    </div>
                </div>
                <Col
                    xs={12}
                    style={{ overflowY: "scroll", height: "100%", maxHeight: "40vh" }}
                >
                    <Table hover size="md">
                        <thead>
                            <tr>
                                <th>
                                    {props.formik.values.type === "service" &&
                                        <input type="checkbox" className="checkbox-table"
                                            checked={_pos.length === selected.length}
                                            onChange={() => { }}
                                            onClick={() => _pos.length === selected.length ? selectAll([]) : selectAll(_pos.map(p => p.uid))}
                                        />}
                                </th>
                                <th>Name</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {_pos
                                .sort((a, b) => {
                                    if (a.name < b.name) { return -1; }
                                    if (a.name > b.name) { return 1; }
                                    return 0;
                                })
                                .filter(pos => pos.state === props.formik.values.state)
                                .map(pos => (
                                    <tr key={pos.uid} onClick={() => handleSelect(pos.uid)}>
                                        <td>
                                            <input type="checkbox" className="checkbox-table"
                                                checked={selected.includes(pos.uid)}
                                                onChange={() => { }}
                                                onClick={() => handleSelect(pos.uid)}
                                            />
                                        </td>
                                        <td>{pos.name}</td>
                                        <td>{pos.description}</td>
                                    </tr>
                                ))}

                        </tbody>
                    </Table>
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.toggleManagePOS}>
                    Cancel
               </Button>
                <Button variant="success" onClick={() => {
                    props.setSelectedPOS(selected)
                    props.toggleManagePOS()
                }}>
                    Save
               </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default PreLoader

function PreLoader(props) {
    const [document, setDocument] = useState({})
    const [uid] = window.location.pathname.split("/").reverse()

    useEffect(() => {
        if (uid && window.location.pathname.includes("edit")) {
            crud.getClient(uid).then(({ data }) => {
                setDocument(data.payload)
            })
        }
    }, [uid])
    if (uid && !document.uid && window.location.pathname.includes("edit")) {
        return (<div className="d-flex align-items-center">
            <div className="mr-2">Loading...</div>
            <div className="spinner spinner-primary mr-10"></div>
        </div>)
    }
    return <Campaign {...props} document={document} />
}
function TasksTypeColumnFormatter({ row }) {
    const types = {
        "File (photo)": "success",
        Rate: "warning",
        Comment: "info",
        "Yes/No": "primary",
        Quantity: "danger",
    };
    return (
        <h5>
            {row.input_type.map((input, key) => (
                <Badge key={key} variant={types[input] || "danger"} className="p-2 mx-1">
                    {input || "null"}
                </Badge>
            ))}
        </h5>
    );
}